var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('c-source-page',{attrs:{"table":_vm.table,"columns":_vm.columns,"filter":_vm.filter,"pagination":_vm.pagination,"resource":"custom_pages","createButtonText":"新建页面"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }